export const SESSION_ID_STORAGE_KEY = 'machadalo-setup-wizard-session-id';
/** @deprecated Server-only persistence; cleared on wizard init */
export const LEGACY_DRAFT_STORAGE_KEY = 'machadalo-onboarding-v1';
export const STORAGE_KEY = LEGACY_DRAFT_STORAGE_KEY;
export const SCHEMA_VERSION = 7;

export const STEP_ORDER = [
  'organisation',
  'account',
  'organisation_mapping',
  'profile_users',
  'whatsapp',
  'campaign',
  'form',
];

export const INITIAL_STEP_STATUSES = {
  organisation: 'pending',
  account: 'pending',
  organisation_mapping: 'pending',
  profile_users: 'pending',
  whatsapp: 'pending',
  campaign: 'pending',
  form: 'pending',
};

export const DEFAULT_OBJECT_PERMISSIONS = [
  { id: '1', name: 'BASEUSER', view: true, update: false, create: false, delete: false },
  { id: '2', name: 'PROFILE', view: true, update: true, create: true, delete: false },
  { id: '3', name: 'ORGANISATION', view: true, update: true, create: false, delete: false },
];

export const DEFAULT_GENERAL_PERMISSIONS = [
  { id: '1', name: 'can_view_organisation_list', isAllowed: true },
  { id: '2', name: 'can_view_campaignlist_button_on_menu', isAllowed: true },
  { id: '3', name: 'can_view_client_onboarding_page', isAllowed: false },
];

export const createInitialOrganisationMapping = () => ({
  firstCategory: null,
  firstOrganisation: null,
  secondCategory: null,
  secondOrganisation: null,
});

export const createInitialDraft = () => ({
  profile_users: {
    clone_from_profile_id: null,
    profile_name: '',
    permissions_source: 'license',
  },
  account: {
    account_id: '',
    name: '',
    phone: '',
    email: '',
    address: '',
    reference_name: '',
    reference_phone: '',
    reference_email: '',
    comments: '',
    contacts: [],
  },
  organisation_mapping: createInitialOrganisationMapping(),
  organisation: {
    name: '',
    mobile: '',
    email: '',
    category: '',
    business_type: [],
    business_subtype: [],
    selectedBusinessTypes: [],
    selectedBusinessSubTypes: [],
    subdomain: '',
    comments: '',
    sessionTimeoutDays: '0',
    sessionTimeoutHours: '8',
    sessionTimeoutMinutes: '0',
    logoFileName: '',
    license_id: '',
    license_alias: '',
    license_permission_profile_id: '',
    license_permission_profile_name: '',
  },
  objectPermissions: DEFAULT_OBJECT_PERMISSIONS.map((p) => ({ ...p })),
  generalPermissions: DEFAULT_GENERAL_PERMISSIONS.map((p) => ({ ...p })),
  users: [],
  whatsapp: {
    app_id: '',
    app_name: '',
    app_type: 'whatsapp',
    wa_phone_number: '',
    wa_phone_number_id: '',
    waba_id: '',
    user_access_token: '',
    is_active: true,
    mongo_id: null,
  },
  campaign_setup: {
    primary_goal: '',
    campaigns: [],
  },
});

export const createFreshState = () => ({
  version: SCHEMA_VERSION,
  currentStep: 1,
  steps: { ...INITIAL_STEP_STATUSES },
  draft: createInitialDraft(),
  updatedAt: new Date().toISOString(),
});
